module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"title":"从素材库选取图片","empty":"暂时没有图片","tags":{"thumbnail":"@:common.project封面","cover":"微信分享封面","logo":"企业logo"},"messagebox":{"remove":{"title":"从素材库中移除该图片?","message":"注意，该操作不会使之前引用的文件失效"},"close":{"title":"请保持素材库打开","message":"上传文件中，请勿关闭素材库"},"save":{"title":"请选择图片后保存","message":"单击某个图片来选中，或点击取消按钮来关闭素材库"}},"imageUploading":"图片上传中"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/plugins/media/image.dialog.vue
// module id = 345
// module chunks = 3